import { render, staticRenderFns } from "./requests-tile.vue?vue&type=template&id=1f805a9a&"
import script from "./requests-tile.vue?vue&type=script&lang=js&"
export * from "./requests-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports